import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getDenominationDashboardSavedBaptized = ({
  denominationId,
  startDate,
  endDate
}) => {
  if (startDate && endDate) {
    return axios.get(
      `/denominations/${denominationId}/saved-baptized-quarterly?start_date=${startDate}&end_date=${endDate}`
    );
  }

  return axios.get(`/denominations/${denominationId}/saved-baptized-quarterly`);
};

export const useDenominationDashboardSavedBaptized = ({
  config,
  denominationId,
  startDate,
  endDate
} = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "denomination-dashboard-saved-baptized",
      denominationId,
      startDate,
      endDate
    ],
    queryFn: () =>
      getDenominationDashboardSavedBaptized({
        denominationId,
        startDate,
        endDate
      }),
    enabled: !!denominationId,
    select: data => data.result
  });
};
